import React, { useEffect } from 'react';
import AllRoutes from '../nametitle/AllRoutes';
import { useState } from 'react';
import { LoadAllTemoignage } from '../actions/Temoignages/TemoignageAction';
import { Localvalue } from '../nametitle/localValue';
import LoaderBootStrap from '../components/admin/dasboard/LoaderBootStrap';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import { responsiveTemoignage } from '../nametitle/ConfigCarouselle';
import { MdInsertEmoticon } from 'react-icons/md';
import { CreateEmail } from '../actions/Emails/EmailsAction';
import { getDataFromFile } from '../actions/SearchAction';



const TemoignagePage = () => {
    const bgImg = "https://images.pexels.com/photos/6567283/pexels-photo-6567283.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";

    const [emailsend, setemailsend] = useState("");
    const [search, setsearch] = useState("");
    const [TemoignageList, setTemoignageList] = useState([]);
    const [TemoignageListSearch, setTemoignageListSearch] = useState([]);

    const handleSearch = (e) => {
        e.preventDefault();
        setsearch(e.target.value); //name.includes('J')
        console.log(e.target.value);
        let _users = TemoignageListSearch.filter((user) =>
            user.title.toLowerCase().includes(e.target.value.toLowerCase())
        );
        let _description = TemoignageListSearch.filter((user) =>
            user.description.toLowerCase().includes(e.target.value.toLowerCase())
        );
        console.log(_users);
        setTemoignageList(_users /*&& _description*/ );
    };

    useEffect(() => {
        const object = getDataFromFile(Localvalue.temoignagesData);
        setTemoignageList(object);
        setTemoignageListSearch(object);
        LoadAllTemoignage(setTemoignageList, setTemoignageListSearch);
    }, [])
    return (
        <div>
            <div className="container py-5">
                <div class='py-2 '>
                    <div class='text-3xl font-bold flex space-x-2 items-center '><span className="translatable">Témoignages</span> <MdInsertEmoticon className="h-7 w-7" /></div>
                </div>
                <div className="mb-5">
                    <div className="input-group">
                        <input type="text" value={search} onChange={(e) => { handleSearch(e) }} className="form-control p-3 translatable" placeholder="rechercher ..." />
                        <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
                    </div>
                </div>
                <div className="row g-5">

                    <div className="col-lg-8 min-h-screen">
                        {
                            TemoignageList && TemoignageList.length > 0 ?
                                (
                                    TemoignageList.map((item) => {
                                        return (
                                            <div className="blog-item mb-5 ">
                                                <a className=" w-full row g-0 bg-gray-100 hover:bg-gray-200 overflow-hidden " href={`${AllRoutes.temoignage}/${String(item._id).replaceAll(" ", "-")}`}
                                                    onClick={() => {
                                                        localStorage.setItem(Localvalue.idTemoignage, item._id)
                                                        localStorage.setItem(Localvalue.contentTemoignage, item.content);
                                                    }}>
                                                    <div className="col-12 col-sm-5 h-100">
                                                        <img className="img-fluid h-100" src={`${item.coverPicture}`} style={{ objectFit: "cover" }} />
                                                    </div>
                                                    <div className="col-12 col-sm-7 h-100 d-flex flex-column justify-content-center">
                                                        <div className="p-4">
                                                            <div className="d-flex mb-3">
                                                                <small className="me-3 translatable">témoignage</small>
                                                                <small></small>
                                                            </div>
                                                            <h5 className="text-uppercase mb-3 translatable">{item.title}</h5>
                                                            <p className="line-clamp-4 translatable">{item.description}</p>
                                                            <a className="btn btn-danger text-lime-50 text-uppercase" href={`${AllRoutes.temoignage}/${String(item.title).replaceAll(" ", "-")}`}
                                                                onClick={() => {
                                                                    localStorage.setItem(Localvalue.idTemoignage, item._id)
                                                                    localStorage.setItem(Localvalue.contentTemoignage, item.content);
                                                                }}><span className="translatable">Lire ...</span><i className="bi text-lime-50 bi-chevron-right"></i></a>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        )
                                    })
                                ) :
                                <LoaderBootStrap />
                        }

                    </div>


                    <div className="col-lg-4">

                        {
                            /*
                            <div className="mb-5">
                            <h3 className="text-uppercase border-start border-5 border-primary ps-3 mb-4">Recent Post</h3>
                            <Carousel responsive={responsiveTemoignage} infinite  >
                                {
                                    TemoignageList.map((item) => {
                                        return (
                                            <div className="d-flex overflow-hidden mb-3">
                                                <img className="img-fluid" src={item.coverPicture} style={{ width: "100px", height: "100px", objectFit: "cover" }} alt="" />
                                                <a href="" className="h5 d-flex align-items-center bg-light px-3 mb-0">{item.title}
                                                </a>
                                            </div>
                                        )
                                    })
                                }
                            </Carousel>

                        </div>
                            */
                        }


                        <form className="relative"
                            onSubmit={(e) => {
                                e.preventDefault();
                                CreateEmail(emailsend)
                            }}
                        >
                            <div className="bg-light text-center  " style={{ padding: "30px" }}>
                                <p className="text-left text-lg translatable">Envoyer votre email </p>
                                <div className="flex">
                                    <input type="email" value={emailsend} onChange={(e) => { setemailsend(e.target.value) }} className="form-control bg-white border-0 px-4 py-2 visible translatable" placeholder="titre" />
                                    <button type="submit" className="btn bg-lime-500  py-2 px-4 translatable">Envoyer </button>
                                </div>
                            </div>
                        </form>

                    </div>

                </div>
            </div>

        </div>
    )
}

export default TemoignagePage;
